import { apiRequest } from './apiClient';

export const TableColumnPreferenceId = {
    PAYMENTS: 'payments',
} as const;

export type TableColumnPreferenceIdValue =
    (typeof TableColumnPreferenceId)[keyof typeof TableColumnPreferenceId];

export interface TableColumnPreference {
    visibleColumnKeys: string[];
    columnOrder: string[];
}

type TableColumnPreferenceApi = {
    visible_column_keys: string[];
    column_order: string[];
};

type TableColumnPreferencesApiResponse = {
    data: Partial<Record<TableColumnPreferenceIdValue, TableColumnPreferenceApi>>;
};

type SavedTableColumnPreferenceApiResponse = {
    data: TableColumnPreferenceApi & {
        table_id: TableColumnPreferenceIdValue;
    };
};

function mapPreference(preference: TableColumnPreferenceApi): TableColumnPreference {
    return {
        visibleColumnKeys: preference.visible_column_keys,
        columnOrder: preference.column_order,
    };
}

export async function getTableColumnPreferences(): Promise<
Partial<Record<TableColumnPreferenceIdValue, TableColumnPreference>>
> {
    const response = await apiRequest<TableColumnPreferencesApiResponse>(
        '/api/account/table-column-preferences',
        'GET',
    );
    const payments = response.data[TableColumnPreferenceId.PAYMENTS];

    return payments
        ? { [TableColumnPreferenceId.PAYMENTS]: mapPreference(payments) }
        : {};
}

export async function saveTableColumnPreference(
    tableId: TableColumnPreferenceIdValue,
    preference: TableColumnPreference,
): Promise<TableColumnPreference> {
    const response = await apiRequest<SavedTableColumnPreferenceApiResponse>(
        `/api/account/table-column-preferences/${tableId}`,
        'PUT',
        {
            body: {
                visible_column_keys: preference.visibleColumnKeys,
                column_order: preference.columnOrder,
            },
        },
    );

    return mapPreference(response.data);
}

export async function resetTableColumnPreference(
    tableId: TableColumnPreferenceIdValue,
): Promise<void> {
    await apiRequest(`/api/account/table-column-preferences/${tableId}`, 'DELETE');
}
